import { render, staticRenderFns } from "./CMSPartial.vue?vue&type=template&id=0c615ad6&scoped=true&lang=pug&"
import script from "./CMSPartial.vue?vue&type=script&lang=js&"
export * from "./CMSPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c615ad6",
  null
  
)

export default component.exports